<template>
  <div class="container">
    <head-component/>
    <StatsCardsComponent/>
    <div class="row my-5">
      <div class="col-12 col-md-6 mb-3">
        <OsChartComponent class="my-3"/>
      </div>
      <div class="col-12 col-md-6 mb-3">
        <WebChartComponent class="my-3"/>
      </div>

    </div>
    <div class="row my-5">
      <div class="col-12 col-md-4 mb-3">
        <TopIpsComponent class="my-3"/>
      </div>
      <div class="col-12 col-md-4 mb-3">
        <TopCountriesComponent class="my-3"/>
      </div>
      <div class="col-12 col-md-4 mb-3">
        <TopCitiesComponent class="my-3"/>
      </div>

    </div>
    <footer-component/>
  </div>
</template>

<script>

import {defineComponent} from 'vue'
import HeadComponent from "@/components/views/head/HeadComponent.vue";
import FooterComponent from "@/components/views/footer/FooterComponent.vue";
import StatsCardsComponent from "@/components/views/stastistics/adminStatistics/StatsCardsComponent.vue";
import OsChartComponent from "@/components/views/stastistics/adminStatistics/OsChartComponent.vue";
import WebChartComponent from "@/components/views/stastistics/adminStatistics/WebChartComponent.vue";
import TopIpsComponent from "@/components/views/stastistics/adminStatistics/TopIpsComponent.vue";
import TopCountriesComponent from "@/components/views/stastistics/adminStatistics/TopCountriesComponent.vue";
import TopCitiesComponent from "@/components/views/stastistics/adminStatistics/TopCitiesComponent.vue";

export default defineComponent({
  name: "StatisticsComponent",
  /**
   * Components object that stores the list of components used in this module.
   * These components are reusable pieces of UI, each serving a specific purpose in the application.
   *
   * @property {Object} FooterComponent - Manages the footer of the application.
   * @property {Object} HeadComponent - Represents the header or head area of the application.
   * @property {Object} StatsCardsComponent - Displays statistical data in card formats.
   * @property {Object} OsChartComponent - Visualizes operating system statistics in a chart format.
   * @property {Object} WebChartComponent - Visualizes web data or analytics in a chart format.
   * @property {Object} TopIpsComponent - Displays a list of the top (frequently accessed) IP addresses.
   * @property {Object} TopCountriesComponent - Displays statistical data grouped by top countries.
   * @property {Object} TopCitiesComponent - Displays statistical data grouped by top cities.
   */
  components: {
    FooterComponent,
    HeadComponent,
    StatsCardsComponent,
    OsChartComponent,
    WebChartComponent,
    TopIpsComponent,
    TopCountriesComponent,
    TopCitiesComponent
  }
});
</script>

